<template>
  <div class="card-header row">
    <p class="label-text">
      <span data-test="card-title"> {{ title }} </span>
    </p>
    <slot></slot>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
});
</script>

<style scoped>
span {
  font-size: 1.563rem;
}
</style>
